import { Component, OnInit, HostListener } from '@angular/core';
import { Spinkit } from 'ng-http-loader';
import { AppInsightsService } from './framework/service/app-insights.service';
import { BaseUrl } from './framework/constants/url-constants';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { RoutePartsService } from './framework/service/route-parts.service';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { SessionsService } from './sessions/sessions.service';

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  appTitle = BaseUrl.APPTITLE;
  public spinkit = Spinkit;
  pageTitle = "";
  clientDetails;
  logo: string;
  isDarkMode = false;

  constructor(
    public title: Title,
    private readonly appInsightsService: AppInsightsService,
    private readonly router: Router,
    private readonly routePartsService: RoutePartsService,
    private readonly activeRoute: ActivatedRoute,
    private readonly sessionsService: SessionsService
  ) {}
  ngOnInit() {
    this.setInitialData();
    this.changePageTitle();
    this.onload();
    this.sessionsService.currentLogo.subscribe((logo) => {
      this.logo = logo + localStorage.getItem("logoPath");
    });
  }

  @HostListener("keyup", ["$event"]) keyUpEvent(event: Event) {
    this.appInsightsService.logEvent("" + event.type);
  }
  @HostListener("click", ["$event"]) clickEvent(event: Event) {
    this.appInsightsService.logEvent("" + event.type);
  }
  @HostListener("dblclick", ["$event"]) doubleClick(event: Event) {
    this.appInsightsService.logEvent("" + event.type);
  }
  @HostListener("submit", ["$event"]) submit(event: Event) {
    this.appInsightsService.logEvent("" + event.type);
  }
  @HostListener("drag", ["$event"]) drag(event: Event) {
    this.appInsightsService.logEvent("" + event.type);
  }
  @HostListener("drop", ["$event"]) drop(event: Event) {
    this.appInsightsService.logEvent("" + event.type);
  }

  changePageTitle() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((routeChange) => {
        const routeParts = this.routePartsService.generateRouteParts(
           this.router.routerState.snapshot.root
        );
        this.appInsightsService.logPageView(window.location.hash.split("/")[1]);
        if (!routeParts.length) {
          return this.title.setTitle(this.appTitle);
        }

        routeParts.reverse();
        this.pageTitle = routeParts
          .map((part) => part.title)
          .reduce((partA, partI) => `${partI}`);
        this.pageTitle += ` | ${this.appTitle}`;
        this.title.setTitle(this.pageTitle);
      });
  }

  darkmode() {
    const element = document.body;
    this.isDarkMode = !this.isDarkMode;
    element.classList.toggle("dark-mode", this.isDarkMode);
    localStorage.setItem("darkmode", this.isDarkMode.toString());
  }

  onload() {
    this.isDarkMode = localStorage.getItem("darkmode") === "true";
    document.body.classList.toggle("dark-mode", this.isDarkMode);
  }

  setInitialData() {
    this.sessionsService.getClientDetails().subscribe((data) => {
      if (data.id) {
        localStorage.setItem("clientId", data.id);
        localStorage.setItem("logoPath", data.logoPath);
        localStorage.setItem("ApplicationID", data.appId);
        localStorage.setItem("suAppId", data.serviceUserAppId);
        localStorage.setItem("landingPage", data.landingPageUrl);
        localStorage.setItem("primaryAppColour", data.primaryAppColour);
        localStorage.setItem("secondaryAppColour", data.secondaryAppColour);
        localStorage.setItem("isPes", data.isPes);
        document.documentElement.style.setProperty(
          "--primary-color",
          data.primaryAppColour
        );
        document.documentElement.style.setProperty(
          "--secondary-color",
          data.secondaryAppColour
        );
        window.dispatchEvent(new Event("isPes-updated"));
      }
    });
  }
}
